module.exports = __webpack_public_path__ + "static/media/admin.e69875c6.svg";